import api from '../api';

import { ParamsBodyPostValidatePasswordToken } from 'utils/typeServices';

export const PostValidatePasswordToken = async ({ body }: { body: ParamsBodyPostValidatePasswordToken }) => {
    const bodyJson = JSON.stringify({
        CdPerson: body.CdPerson,
        Token: body.Token
    });

    try {
        const { data } = await api.post<{ Data: boolean }>('/v1/Cliente/ValidatePasswordToken', bodyJson);

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
